import { render } from "./AppPrimaryButton.vue?vue&type=template&id=0eb394d4&scoped=true"
import script from "./AppPrimaryButton.vue?vue&type=script&lang=js"
export * from "./AppPrimaryButton.vue?vue&type=script&lang=js"

import "./AppPrimaryButton.vue?vue&type=style&index=0&id=0eb394d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb394d4"]])

export default __exports__